var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookShareZyia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5089 19.1838V16.3418C26.5089 15.276 27.2073 15.0253 27.7035 15.0253H30.7307V10.3378L26.5595 10.32C21.9299 10.32 20.8777 13.8197 20.8777 16.0545V19.1788H18.2V24.0089H20.8777V37.68H26.5089V24.0089H30.3081L30.8 19.1838H26.5089Z",
    fill: "#3e2a52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookShareZyia);
export default __webpack_public_path__ + "static/media/facebook_shareZyia.25a0a24fa47a3964c9e6c520419df457.svg";
export { ForwardRef as ReactComponent };